import { useEffect, useState } from "react";
import {
  Alert, Box, Button, Card, InputAdornment, Table, TableBody, TableCell,
  TableHead, TableRow, TextField, Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { adminApi } from "rsa/adminApi";
import AddCustomerDialog from "./Components/AddCustomerDialog";

// v1-backed replacement for the legacy CustomMaterialTable page — the old
// /admin/getAllCustomers read a customer_registration table that doesn't exist
// in this schema, so the table always came up broken/empty.
const cardSx = { borderRadius: "15px", boxShadow: "rgba(0,0,0,0.1) 0px 10px 15px -3px, rgba(0,0,0,0.05) 0px 4px 6px -2px", p: 2 };

const AdminCustomerPage = () => {
  const [customers, setCustomers] = useState([]);
  const [q, setQ] = useState("");
  const [error, setError] = useState("");
  const [addOpen, setAddOpen] = useState(false);
  const [created, setCreated] = useState(null);

  const load = async (search = q) => {
    try {
      setError("");
      setCustomers(await adminApi("GET", `/admin/customers${search ? `?q=${encodeURIComponent(search)}` : ""}`));
    } catch (e) { setError(e.status === 401 ? "Session expired — sign in again." : e.message); }
  };
  useEffect(() => {
    const t = setTimeout(() => load(), 300);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line

  return (
    <Box mt={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} gap={1}>
        <Typography variant="h6" fontWeight={700}>Customers</Typography>
        <Box display="flex" gap={1}>
          <TextField
            size="small" placeholder="Search name / phone / email" value={q}
            onChange={(e) => setQ(e.target.value)}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
          />
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setAddOpen(true)}>
            Add customer
          </Button>
        </Box>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {created && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setCreated(null)}>
          Customer “{created.name}” created — they can now log in on the mobile app
          with phone {created.phone} (Customer → OTP).
        </Alert>
      )}
      <AddCustomerDialog
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onCreated={(c) => { setCreated(c); load(); }}
      />
      <Card sx={cardSx}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell><TableCell>Phone</TableCell><TableCell>Email</TableCell>
              <TableCell>Address</TableCell><TableCell align="right">Vehicles</TableCell>
              <TableCell align="right">Requests</TableCell><TableCell>Last login</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {customers.length === 0 && (
              <TableRow><TableCell colSpan={7} align="center">No customers</TableCell></TableRow>
            )}
            {customers.map((c) => (
              <TableRow key={c.id} hover>
                <TableCell>{c.name}</TableCell>
                <TableCell>{c.phone || "—"}</TableCell>
                <TableCell>{c.email || "—"}</TableCell>
                <TableCell>{c.address || "—"}</TableCell>
                <TableCell align="right">{c.vehicle_count}</TableCell>
                <TableCell align="right">{c.request_count}</TableCell>
                <TableCell>{c.last_login_at ? new Date(c.last_login_at).toLocaleString() : "never"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Box>
  );
};

export default AdminCustomerPage;
